import React from "react";
import logo from "./../home/imgs/Logo.png";

export default function Footer() {
  return (
    <footer className="bg-customBlue text-white py-12">
      <div className="container mx-auto px-6 lg:px-8">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <img src={logo} alt="GrandshopRwandaLogo" />
          </div>

          {/* Navigation Links */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="hover:text-white text-gray-400 transition"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white text-gray-400 transition"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white text-gray-400 transition"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white text-gray-400 transition"
                >
                  Testimonies
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white text-gray-400 transition"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Signup */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold">Stay Updated</h3>
            <p>
              Sign up for our newsletter to get the latest updates and offers.
            </p>
            <form className="flex flex-col sm:flex-row">
              <input
                type="email"
                placeholder="Your email address"
                className="p-3  text-gray-900 mb-2 sm:mb-0 sm:mr-2"
              />
              <button
                type="submit"
                className="text-white px-6 py-3  shadow-md bg-[#557a82] hover:text-customBlue hover:bg-white transition"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 border-t border-gray-700 pt-6 text-center">
          <p className="text-gray-400">
            &copy; 2024 Grand Shop Rwanda. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
